
  import {defineComponent} from 'vue';
  import ToTop from '@/components/shared/TopButtonComponent.vue';
  import TicketMessageComponent from '@/components/ticketDetail/TicketMessageComponent.vue';
  import TicketInfoComponent from '@/components/ticketDetail/TicketInfoComponent.vue';
  import ProductUsageComponent from '@/components/productDetail/ProductUsageComponent.vue';
  import InformationComponent from '@/components/shared/InformationComponent.vue';
  import PopupComponent from '@/components/shared/PopupComponent.vue';
  import router from "@/router";
  import {mapGetters, mapMutations} from "vuex";
  import Receiver from "@/domain/receiver/Receiver";
  import api from "@/api/backend-api";
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import {Item} from "@/domain/ui/Item";
  import paycoUtils from "@/assets/js/utils";
  import HeaderComponent from "@/components/shared/HeaderComponent.vue";
  import store from "@/store";

  export default defineComponent({
    name: "TicketDetail",
    props: [
        'ticketId'
    ],
    components: {
      HeaderComponent,
      TicketMessageComponent,
      TicketInfoComponent,
      InformationComponent,
      ProductUsageComponent,
      PopupComponent,
      ToTop,
    },
    data() {
      return {
        downloadUrl: '',
        loadingCompleted: false,

        showExtendingPopup: false,
        showExtendingCompletionPopup: false,
        showRefusingPopup: false,
        showRefusingCompletionPopup: false,
        showDeletingPopup: false,
        showDeletingCompletionPopup: false,
        showSavingCompletionPopup: false,
        showSendingPopup: false,

        ticket: {
          ticketId: "",
          ticketPinNumber: "0000-0000-0000-0000",
          isBarcodeType: false,
          validityStartDate: "0000-01-01",
          validityEndDate: "9999-12-31",
          extendedValidityEndDate: '9999-12-31',
          rejectedDate: '9999-12-31',
          ticketCount: 1,
          ticketStatus: "REFUNDED",

          isUsable: false,

          validityExtendable: false,
          canDownloadTicket: false,

          isRefusable: false,

          isUsed: false,

          isRejected: false,

          isRefunding: false,
          isRefunded: false,
          isRefundFailed: false,

          isExpired: false,
          isRefundable: false,
        },

        order: {
          // orderId: "201020102010",
          ordererName : "테스터",
          ordererPhoneNumber: "000-0000-0000",
          message:"테스트 메세지입니다.",
        },

        approval: {
          approvalYmdt: "0000. 01. 01 00:00",
          approvalNo: "2830408399298484",
          paymentMethod: "테스트 결제수단",
          usedStore: "테스트 매장",
          approvalInquiry: "000-0000-0000",
        },

        product: {
          // productId: 1097,
          productName: "테스트 메뉴",
          productImageUrl: "//image.toast.com/aaaaej/giftshop/product/product_1552285432290.png",
          informationUseText: "테스트용 이용정보",
          usableMerchantText: "테스트 사용가능 매장",
          unusableMerchantText: "테스트 사용불가 매장",
          caution: "테스트 유의사항",
          contactUs: "테스트 고객센터",
          contactUsTel: "0000-0000",
          brandName : "테스트 브랜드",
        },
        InformationArray: [] as Array<Item>
      }
    },
    mounted(): void {
      this.ticket.ticketId = this.ticketId;
      api.getTicketDetail(this.ticketId)
      .then(response => {
        if (response.data.code === 4444) {
          if (store.getters['AppYnStore/isApp']) {
            router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
          } else {
            store.commit('NextViewStore/setNextView', new NamedRouting('TicketDetailView', {ticketId: this.ticketId}));
            router.push(new NamedRouting('NonMemberView', store.state.ChannelStore.channelId));
          }
          return;
        }

        const ticketData = response.data.result;
        this.ticket.ticketPinNumber = ticketData.serialNo;
        this.ticket.isBarcodeType = paycoUtils.convertYnToBoolean(ticketData.barcodeTypeYn);
        this.ticket.validityStartDate = ticketData.validityStartYmd;
        this.ticket.validityEndDate = ticketData.validityEndYmd;
        this.ticket.extendedValidityEndDate = ticketData.nextValidityEndYmd;
        this.ticket.rejectedDate = ticketData.refusedYmd;

        this.ticket.ticketStatus = ticketData.ticketStatus;

        this.ticket.isUsable = ticketData.ticketStatus === 'ISSUED' && paycoUtils.convertYnToBoolean(ticketData.usableYn) && paycoUtils.convertYnToBoolean(ticketData.enableYn);
        this.ticket.isUsed = ticketData.ticketStatus === 'USED' && paycoUtils.convertYnToBoolean(ticketData.usedYn);
        this.ticket.isRejected = ticketData.ticketStatus === 'REJECT' && paycoUtils.convertYnToBoolean(ticketData.refusedYn);
        this.ticket.isRefunding = ticketData.ticketStatus === 'REFUNDING';
        this.ticket.isRefunded = ticketData.ticketStatus === 'REFUNDED' && paycoUtils.convertYnToBoolean(ticketData.refundedYn);
        this.ticket.isRefundFailed = ticketData.ticketStatus === 'REFUNDFAIL';
        this.ticket.isExpired = ticketData.ticketStatus === 'ISSUED' && paycoUtils.convertYnToBoolean(ticketData.expiredYn);

        this.ticket.validityExtendable = paycoUtils.convertYnToBoolean(ticketData.validityExtendableYn);
        this.ticket.canDownloadTicket = paycoUtils.convertYnToBoolean(ticketData.storableYn);
        this.ticket.isRefusable = paycoUtils.convertYnToBoolean(ticketData.refusableYn);
        this.ticket.isRefundable = paycoUtils.convertYnToBoolean(ticketData.refundableYn);

        this.order.ordererName = ticketData.ordererName;
        this.order.ordererPhoneNumber = ticketData.ordererTelNo;
        this.order.message = ticketData.receiveMessage;

        this.approval.approvalYmdt = ticketData.useYmdt;
        this.approval.approvalNo = ticketData.admissionNo;
        this.approval.paymentMethod = ticketData.paymentMethod;
        this.approval.usedStore = ticketData.useMrcName;
        this.approval.approvalInquiry = ticketData.contactUsTel;

        this.product.productName = ticketData.productName;
        this.product.productImageUrl = ticketData.productImageUrl;
        this.product.informationUseText = ticketData.informationUseText;
        this.product.usableMerchantText = ticketData.usableMerchantText;
        this.product.unusableMerchantText = ticketData.unusableMerchantText;
        this.product.caution = ticketData.caution;
        this.product.brandName = ticketData.brandName;
        this.product.contactUs = ticketData.contactUs;
        this.product.contactUsTel = ticketData.contactUsTel;
      })
      .then(() => {
        this.InformationArray.push(new Item('유효기간', this.ticket.validityStartDate + ' ~ ' + this.ticket.validityEndDate));
        this.InformationArray.push(new Item('수량', this.ticket.ticketCount + '개'));
        this.InformationArray.push(new Item('사용처', this.product.brandName));

        this.loadingCompleted = true;
      }).then(() => {
        api.downloadTicket(this.ticketId)
        .then(response => {
          // Blob 데이터 형태로 넘어옴
          this.downloadUrl = window.URL.createObjectURL(new Blob([response.data as any]));

        })
        .catch((error) => {
          console.log("Error: " + error);
        });
      })
      .catch(error => {
        console.log("Error: " + error);
        this.$router.back();
      });
    },
    methods: {
      confirmExtending(isConfirmed: boolean): void {
        if (isConfirmed) {
          this.extendValidityOfTicket();
        }
        this.toggleExtendingPopup();
      },
      confirmRefusing(isConfirmed: boolean): void {
        if (isConfirmed) {
          this.refuseTicket();
        }
        this.toggleRefusingPopup();
      },
      confirmDeleting(isConfirmed: boolean): void {
        if (isConfirmed) {
          this.deleteTicket();
        }
        this.toggleDeletingPopup();
      },
      toggleExtendingPopup(): void {
        this.showExtendingPopup = !this.showExtendingPopup;
      },

      openExtendingCompletionPopup(): void {
        this.showExtendingCompletionPopup = true;
      },
      confirmExtendingCompletionPopup(): void {
        router.go(0);
      },
      toggleRefusingPopup(): void {
        this.showRefusingPopup = !this.showRefusingPopup;
      },
      toggleRefusingCompletionPopup(): void {
        this.showRefusingCompletionPopup = !this.showRefusingCompletionPopup;
      },
      toggleDeletingPopup(): void {
        this.showDeletingPopup = !this.showDeletingPopup;
      },
      toggleDeletingCompletionPopup(): void {
        this.showDeletingCompletionPopup = !this.showDeletingCompletionPopup;
      },
      toggleSavingCompletionPopup(): void {
        this.showSavingCompletionPopup = !this.showSavingCompletionPopup;
      },
      toggleSendingPopup(): void {
        this.showSendingPopup = !this.showSendingPopup;
      },
      confirmSending(isConfirmed: boolean): void {
        if (isConfirmed) {
          this.clearReceiverList();
          this.addReceiver(new Receiver({
            receiverName: this.order.ordererName,
            receiverTelNo: this.order.ordererPhoneNumber,
            ticketCount: 1
          }));

          router.push(new NamedRouting('HomeView'));
        }
        this.toggleSendingPopup();
      },
      extendValidityOfTicket() {
        api.extendValidityOfTicket(this.ticketId)
        .then(response => {
          if (response.data.code === 0) {
            this.openExtendingCompletionPopup();
            return;
          }

          if (response.data.code === 4444) {
            if (store.getters['AppYnStore/isApp']) {
              router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
            } else {
              store.commit('NextViewStore/setNextView', new NamedRouting('TicketDetailView', {ticketId: this.ticketId}));
              router.push(new NamedRouting('NonMemberView', store.state.ChannelStore.channelId));
            }
            return;
          }

          alert('선물 유효기간 연장이 실패하였습니다. 잠시 후, 다시 시도해주세요.');
        })
        .catch(error => {
          console.log("Error: " + error);
        });
      },
      refuseTicket() {
        // TODO: 거절기능 테스트
        api.refuseTicket(this.ticketId)
        .then(response => {
          if (response.data.code === 0) {
            // this.toggleRefusingCompletionPopup();
            alert('선물 삭제가 완료되었습니다.');
            router.push(new NamedRouting('MyUsableTicketView'));
            return;
          }

          if (response.data.code === 4444) {
            if (store.getters['AppYnStore/isApp']) {
              router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
            } else {
              store.commit('NextViewStore/setNextView', new NamedRouting('TicketDetailView', {ticketId: this.ticketId}));
              router.push(new NamedRouting('NonMemberView', store.state.ChannelStore.channelId));
            }
            return;
          }

          alert('선물 거절이 실패하였습니다. 잠시 후, 다시 시도해주세요.');
        })
        .catch(error => {
          console.log("Error: " + error);
        });
      },
      deleteTicket() {
        // TODO: 삭제기능 테스트
        api.deleteTicket(this.ticketId)
        .then(response => {
          if (response.data.code === 0) {
            // this.toggleDeletingCompletionPopup();
            alert('선물 삭제가 완료되었습니다.');
            router.push(new NamedRouting('MyUsableTicketView'));
            return;
          }

          if (response.data.code === 4444) {
            if (store.getters['AppYnStore/isApp']) {
              router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
            } else {
              store.commit('NextViewStore/setNextView', new NamedRouting('TicketDetailView', {ticketId: this.ticketId}));
              router.push(new NamedRouting('NonMemberView', store.state.ChannelStore.channelId));
            }
            return;
          }

          alert('선물 삭제가 실패하였습니다. 잠시 후, 다시 시도해주세요.');
        })
        .catch(error => {
          console.log("Error: " + error);
        });
      },
      downloadTicket(): void {
        api.downloadTicket(this.ticketId)
        .then(response => {
          // Blob 데이터 형태로 넘어옴
          this.forceFileDownload(response);
        })
        .catch((error) => {
          console.log("Error: " + error);
        });

        this.toggleSavingCompletionPopup();
      },
      forceFileDownload(response: any){
        const url = window.URL.createObjectURL(new Blob([response.data]));

        const link = document.createElement('a');
        link.href = url;
        this.downloadUrl = url;
        link.setAttribute('download','payco_' + this.ticketId + '.png');

        document.body.appendChild(link);
        link.click();
      },
      ...mapMutations('ReceiverStore', [
        'addReceiver',
        'clearReceiverList'
      ])
    },
    computed: {
      showDimmed(): boolean {
        return this.showExtendingPopup
            || this.showExtendingCompletionPopup
            || this.showRefusingPopup
            || this.showRefusingCompletionPopup
            || this.showDeletingPopup
            || this.showDeletingCompletionPopup
            || this.showSavingCompletionPopup
            || this.showSendingPopup;
      },
      badgeForTicketStatus(): Badge {
        return {
          is_done: this.ticket.isUsed,
          is_refuse: this.ticket.isRejected,
          is_refund: this.ticket.isRefunded,
          is_passed: this.ticket.isExpired || this.ticket.isRefunding
        };
      },
      isDeletable(): boolean {
        return this.ticket.isUsed
            || (this.ticket.isExpired && !this.ticket.isRefundable)
            || this.ticket.isRefunded
            || this.ticket.isRefundFailed
            || this.ticket.isRejected;
      },
      extendedValidityString(): string {
        const extendedValidityEndDateObj = new Date(this.ticket.extendedValidityEndDate);
        return extendedValidityEndDateObj.getFullYear() + '년 ' + (extendedValidityEndDateObj.getMonth() + 1) + '월 ' + extendedValidityEndDateObj.getDate() + '일';
      },
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    }
  });

  interface Badge {
    is_done: boolean;
    is_refuse: boolean;
    is_refund: boolean;
    is_passed: boolean;
  }
